import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

export function initSponsorsSlider() {
  const sectionEl = document?.querySelector(".js-sponsors");
  const prevBtn = sectionEl?.querySelector(".sponsors__slider-nav-btn--prev");
  const nextBtn = sectionEl?.querySelector(".sponsors__slider-nav-btn--next");
  if (!sectionEl || typeof Swiper === "undefined") return;

  const sliderEl = sectionEl?.querySelector(".sponsors__slider");
  if (!sliderEl) return;

  let swiperInstance = null;
  let releaseViewport = () => {};
  const mobileQuery = window.matchMedia("(max-width: 767px)");

  const initSwiper = () => {
    if (swiperInstance) return;

    swiperInstance = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      loop: true,
      speed: 500,
      grabCursor: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });

    releaseViewport();
    releaseViewport = bindSwiperAutoplayToViewport(swiperInstance);
  };

  const destroySwiper = () => {
    if (!swiperInstance) return;
    releaseViewport();
    releaseViewport = () => {};
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  };

  const handleViewportChange = () => {
    if (mobileQuery.matches) {
      initSwiper();
    } else {
      destroySwiper();
    }
  };

  handleViewportChange();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", handleViewportChange);
  } else {
    mobileQuery.addListener(handleViewportChange);
  }
}
